(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("@piwikpro/tracking-base-library")) : typeof define === "function" && define.amd ? define(["exports", "@piwikpro/tracking-base-library"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global["tracking-base-library"] = {}, global.PiwikPRO));
})(this, function(exports2, PiwikPRO) {
  "use strict";
  function _interopNamespaceDefault(e) {
    const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
    if (e) {
      for (const k in e) {
        if (k !== "default") {
          const d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: () => e[k]
          });
        }
      }
    }
    n.default = e;
    return Object.freeze(n);
  }
  const PiwikPRO__namespace = /* @__PURE__ */ _interopNamespaceDefault(PiwikPRO);
  const version = "2.5.0";
  const initialize = (...args) => {
    if (typeof window !== "undefined") {
      PiwikPRO.Miscellaneous.setTrackingSourceProvider("react", version);
    }
    PiwikPRO__namespace.default.initialize(...args);
  };
  const index = {
    ...PiwikPRO__namespace.default,
    initialize
    // fixes some 'The inferred type of 'default' cannot be named without a reference to ...' error
  };
  exports2.default = index;
  Object.keys(PiwikPRO).forEach((k) => {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(exports2, k)) Object.defineProperty(exports2, k, {
      enumerable: true,
      get: () => PiwikPRO[k]
    });
  });
  Object.defineProperties(exports2, { __esModule: { value: true }, [Symbol.toStringTag]: { value: "Module" } });
});
//# sourceMappingURL=index.umd.cjs.map
